import httpHeaders from './httpHeaders';
import getCookieValue from './cookieExpression';

const defaultConfig = {
  mode: 'cors',
  credentials: 'include',
};

export default (config, headers) => {
  defaultConfig.headers = Object.assign(httpHeaders(getCookieValue()), headers);

  const devKey = localStorage.getItem('@LT/DEV_KEYS');

  const fetchObject = Object.assign(defaultConfig, config, {
    body: JSON.stringify(config.body),
  });

  if (process.env.NODE_ENV === 'development' && devKey) {
    fetchObject.headers.Authorization = `Basic ${String(devKey)}`;
  }

  return fetchObject;
};



// WEBPACK FOOTER //
// ./src/config/fetch/fetchConfig.js